import { instance } from '../../util/http'
import apis from '../../config/apis'

const getModule = () => {
    return instance.get(apis.Page.Index)
}
// 跳转积分商城
const bannerIntegral = (data) => {
    return instance.post(apis.Page.BannerIntegral,data)
}
const GetSubscriptList = () => {
    return instance.get(apis.Page.GetSubscriptList)
}
// 获取限购商品详情
const GetLimitGoodsDetail = (data) => {
    return instance.post(apis.Goods.GetLimitGoodsDetail,data)
}
// 关注公众号二维码
const FollowImageUrl = (data) => {
    return instance.get(apis.Page.FollowImageUrl,data)
}
export default {
    getModule,
    GetLimitGoodsDetail,
    GetSubscriptList,
    bannerIntegral,
    FollowImageUrl
}